import { useMemo } from "react";

import { fullMonthAndYear } from "@similarweb/pro-logic-components";
import { colorsPalettes } from "@similarweb/styles";
import { PixelPlaceholderLoader } from "@similarweb/ui-components";
import { Flex } from "@similarweb/ui-components/foundations";

import { translate } from "app/filters/i18nFilter";

import { IndustryOverviewTitle } from "../../../components/common/IndustryOverviewTitle/IndustryOverviewTitle";
import { getFromTo } from "../utils";

interface IHeader {
    isLoading: boolean;
    title: string;
    showVsDate?: boolean;
}

export const Header = ({ isLoading, title, showVsDate = false }: IHeader) => {
    const fromTo = getFromTo();

    const headerConfig = useMemo(() => {
        const titleKey = title;

        const getHeaderFilters = () => {
            if (showVsDate) {
                return [
                    {
                        filter: "date",
                        value: {
                            from: fromTo.from,
                            to: fromTo.to,
                            dateSeparator: translate("global.vs"),
                            format: fullMonthAndYear,
                        },
                    },
                ];
            }
            return [
                {
                    filter: "date",
                    value: {
                        to: fromTo.to,
                        format: fullMonthAndYear,
                    },
                },
            ];
        };

        return {
            title: titleKey,
            filters: getHeaderFilters(),
        };
    }, [fromTo.to]);

    const addToDashboardProps = {
        isVisible: false,
    };

    const headerProps = useMemo(() => {
        return {
            title: headerConfig.title,
            filters: headerConfig.filters,
        };
    }, [headerConfig.filters, headerConfig.title]);

    return isLoading ? (
        <Flex
            gap="10px"
            minHeight="53px"
            padding="16px 24px 8px 24px"
            flexDirection="column"
            borderBottom={`1px solid ${colorsPalettes.carbon[100]}`}
        >
            <PixelPlaceholderLoader
                width={185}
                height={22}
            />
            <PixelPlaceholderLoader
                width={109}
                height={14}
            />
        </Flex>
    ) : (
        <IndustryOverviewTitle
            headerProps={headerProps}
            addToDashboardProps={addToDashboardProps}
        />
    );
};
